// Automatizaciones creadas desde la Consola (objeto automatizacion de la app, D35). Por ahora: avisos de licencias 3CX a
// Partners con sus propios dias, idioma, buzon, texto y copias. Las fijas siguen en api/automatizaciones.ts.
import { create, listAll, update } from './rest';

export type TipoCreada = 'LICENCIAS';
export type AutoCreada = {
  id: string;
  nombre: string;
  tipo: TipoCreada;
  activa: boolean;
  oculta: boolean;
  buzon: string;
  asunto: string;
  cuerpo: string;
  dias: number;
  idioma: '' | 'ES' | 'EN';
  hora: number | null;
  copias: string;
};

type Raw = {
  id: string;
  name: string;
  tipo: string | null;
  activa: boolean | null;
  oculta: boolean | null;
  buzon: string | null;
  asunto: string | null;
  cuerpo: string | null;
  dias: number | null;
  idioma: string | null;
  horaEnvio: number | null;
  copias: string | null;
};

const aCreada = (r: Raw): AutoCreada => ({
  id: r.id,
  nombre: r.name,
  tipo: 'LICENCIAS',
  activa: !!r.activa,
  oculta: !!r.oculta,
  buzon: r.buzon ?? '',
  asunto: r.asunto ?? '',
  cuerpo: r.cuerpo ?? '',
  dias: r.dias ?? 60,
  idioma: r.idioma === 'ES' || r.idioma === 'EN' ? r.idioma : '',
  hora: r.horaEnvio,
  copias: r.copias ?? '',
});

export const automatizacionesCreadas = async () => (await listAll<Raw>('automatizaciones', { orderBy: 'createdAt[AscNullsLast]', depth: 0 }, 100)).map(aCreada);

const cuerpo = (a: Omit<AutoCreada, 'id'>) => ({
  name: a.nombre.trim() || 'Aviso de licencias',
  tipo: a.tipo,
  activa: a.activa && !a.oculta,
  oculta: a.oculta,
  buzon: a.buzon.trim().toLowerCase(),
  asunto: a.asunto,
  cuerpo: a.cuerpo,
  dias: a.dias,
  idioma: a.idioma,
  horaEnvio: a.hora,
  copias: a.copias,
});

export const crearAutomatizacion = (a: Omit<AutoCreada, 'id'>) => create<{ id: string }>('automatizaciones', cuerpo(a));
export const guardarCreada = (a: AutoCreada) => update('automatizaciones', a.id, cuerpo(a));

export const NUEVA_LICENCIAS: Omit<AutoCreada, 'id'> = {
  nombre: 'Aviso de licencias a 60 días',
  tipo: 'LICENCIAS',
  activa: false,
  oculta: false,
  buzon: '3cxrenewals@xmartek.com',
  asunto: 'Licencias 3CX por vencer en {{dias}} días – {{empresa.nombre}}',
  cuerpo:
    'Estimado(a) {{contacto.nombre}}:\n\nLe escribimos para recordarle que estas licencias 3CX de sus clientes **vencen en los próximos {{dias}} días**:\n\n{{licencias.tabla}}\n\nSi desea la **cotización de la renovación**, basta con responder a este correo.\n\nSaludos cordiales,',
  dias: 60,
  idioma: '',
  hora: 7,
  copias: '',
};
